
export default defineNuxtRouteMiddleware((to) => {
  const { t } = useI18n();
  const notificationStore = useNotificationsStore();
  const localePath = useLocalePath();
  const userStore = useUserStore();
  const requiresAuth = to.meta.authRequired ?? to.meta.groups?.includes('private');
  const redirectTo = to.meta.redirectTo ?? '/';

  if (!userStore.isAuthenticated && requiresAuth) {
    // Redirect to the login page if not authenticated
    notificationStore.add({
      status: 'danger',
      message: t('ui.error.code.401.description'),
    });

    // If we want to spot an error, we can use abortNavigation(createError({}))
    return navigateTo(localePath(redirectTo));
  }
});